import React, { useState, useEffect, forwardRef } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { BsBasket3 } from "react-icons/bs";

import "../styles/NavBar.css";
import { useCart } from "./CartContext";
import QuickCheckout from "./QuickCheckout";
import Popup from "./Popup";

const NavBar = forwardRef((props, ref) => {
  const [isSticky, setSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isQuickCheckoutVisible, setQuickCheckoutVisible] = useState(false);
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const token = localStorage.getItem("token");

  const handleScroll = () => {
    // If a informational banner is wanted the below enable the sticky beneath that banner
    // const navbar = document.getElementById("top-header");
    // const sticky = navbar.offsetHeight;

    // Remove this sticky declaration if banner above NavBar is wanted
    const sticky = 1;

    if (window.scrollY >= sticky) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  const handleLogoClick = (event) => {
    if (isOpen) {
      toggleSidebar();
    }
    navigate("/home");
  };

  const handleBasketClick = (event) => {
    if (isOpen) {
      toggleSidebar();
    }
    setQuickCheckoutVisible(false);
    navigate("/cart");
  };

  const closeCheckout = () => {
    setQuickCheckoutVisible(false);
    document.body.classList.remove("no-scroll");
  };

  useEffect(() => {
    const handleShowCheckout = () => {
      setQuickCheckoutVisible(true);
      document.body.classList.add("no-scroll");
    };
    window.addEventListener("showCheckout", handleShowCheckout);
    return () => {
      window.removeEventListener("showCheckout", handleShowCheckout);
    };
  }, []);

  const handleOpenPopup = (size) => {
    setIsPopupOpen(true);
    toggleSidebar();
  };

  return (
    <>
      <header
        id="navbar"
        ref={ref}
        className={`header ${isSticky ? "sticky" : ""} ${
          isOpen ? "sidebar-open" : ""
        }`}
      >
        <div className="left">
          <Link className="site-logo" to="/" onClick={handleLogoClick}>
            <img
              // src="/CharlesTimminsLogo.png"
              src="/CTLogo.png"
              alt="Site Logo"
            />
            <div className="typespace-logo">
              <p>Charles Timmins</p>
            </div>
          </Link>
        </div>
        <div className="middle">
          <nav className="nav">
            <NavLink to="/shop" className="nav-link">
              Shop
            </NavLink>
            <NavLink to="/faqs" className="nav-link">
              FAQs
            </NavLink>
            <NavLink to="/contact" className="nav-link">
              Contact us
            </NavLink>
            <NavLink to="/design" className="nav-link">
              Design
            </NavLink>
            <NavLink to="/returns-and-exchanges" className="nav-link">
              Returns and Exchanges
            </NavLink>
            {token && (
              <>
                <NavLink to="/management" className="nav-link">
                  Management
                </NavLink>
              </>
            )}
          </nav>
        </div>
        <div className="right">
          <div className="basket-container">
            <NavLink to="/cart" className="basket" onClick={handleBasketClick}>
              <BsBasket3 />
              <span
                className={`cart-badge ${
                  cartItems.length > 0 ? "visible" : "invisible"
                }`}
              >
                {cartItems.length}
              </span>
            </NavLink>
          </div>
          <div
            className={`hamburger-container ${isOpen ? "open" : ""}`}
            onClick={toggleSidebar}
          >
            <div className="hamburger-icon">
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`sidebar ${isSticky ? "shifted-up" : ""} ${
          isOpen ? "no-scroll sidebar-open" : ""
        }`}
      >
        <nav className="sidebar-nav">
          <div className="sidebar-nav-link" onClick={() => handleOpenPopup()}>
            Join our newsletter
          </div>
          <hr className="sidebar-divider" />
          <NavLink to="/" className="sidebar-nav-link" onClick={toggleSidebar}>
            Home
          </NavLink>
          <NavLink
            to="/shop"
            className="sidebar-nav-link"
            onClick={toggleSidebar}
          >
            Shop
          </NavLink>
          <NavLink
            to="/faqs"
            className="sidebar-nav-link"
            onClick={toggleSidebar}
          >
            FAQs
          </NavLink>
          <NavLink
            to="/contact"
            className="sidebar-nav-link"
            onClick={toggleSidebar}
          >
            Contact us
          </NavLink>
          <NavLink
            to="/design"
            className="sidebar-nav-link"
            onClick={toggleSidebar}
          >
            Design
          </NavLink>
          <NavLink
            to="/returns-and-exchanges"
            className="sidebar-nav-link"
            onClick={toggleSidebar}
          >
            Returns and Exchanges
          </NavLink>
          {token && (
            <>
              <NavLink
                to="/management"
                className="sidebar-nav-link"
                onClick={toggleSidebar}
              >
                Management
              </NavLink>
            </>
          )}
        </nav>
      </div>
      <QuickCheckout
        isVisible={isQuickCheckoutVisible}
        onClose={closeCheckout}
        cartItems={cartItems}
      />
      <Popup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        title="Join our Newsletter"
        description={`Join our newletter to find out the latest in male swimwear`}
        reason="newsletter"
      />
    </>
  );
});

export default NavBar;
